<template>
  <v-container fluid class="mt-2">
    <v-row align="center" justify="center" v-if="parking">
      <template v-for="(slot, idx) in parking.slotsObject">
        <FreeSlot v-if="slot.isFree" :call="slot" @direct-park="directParkStart(slot, $event)" :key="`${idx}-free`" />
        <CallCard v-else :call="slot" :key="`${idx}-call`" />
      </template>
    </v-row>
    <v-dialog v-model="confirmXferDlg" persistent max-width="500px">
      <v-card>
        <v-card-title primary-title>
          <span><v-icon class="mr-3" color="primary">mdi-phone-forward</v-icon>
          {{$t('parking.directPark', { slot: xferSlot })}}? </span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="confirmXferDlg=false" text>{{$t('sipua.xfer.cancel')}}</v-btn>
          <v-btn @click="directPark" text color="primary">{{$t('sipua.xfer.confirm')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import EmbeddedLocalStorage from '@/api/embedded'
import CallCard from './callcard'
import FreeSlot from './freeslot'

export default {
  name: 'parking',
  data () {
    return {
      xferCallId: '',
      xferSlot: '',
      confirmXferDlg: false
    }
  },
  components: { CallCard, FreeSlot },
  computed: {
    ...mapGetters({
      parkings: 'parking/parkings'
    }),
    embedded () {
      return EmbeddedLocalStorage.get()
    },
    parking () {
      return this.parkings?.find((parking) => parseInt(parking.extension) === parseInt(this.$route?.params?.extension))
    }
  },
  methods: {
    ...mapActions({ xferCall: 'sipua/xferCall' }),
    directPark: function () {
      if (this.embedded) {
        this.confirmXferDlg = false
        return
      }
      this.xferCall({ callid: this.xferCallId, number: this.xferSlot })
      this.confirmXferDlg = false
      this.xferSlot = ''
      this.xferCallId = ''
    },
    directParkStart: function (slot, ev) {
      if (this.embedded) {
        return
      }
      this.confirmXferDlg = true
      this.xferSlot = slot.Space
      this.xferCallId = ev.callid
    }
  }
}
</script>

<style scoped>
</style>
